export default __webpack_public_path__ + "static/media/padel-ball.9312d5a5.svg";